import React from 'react';

import DisplayView from './display/DisplayView';
import EditView from './edit/EditView';
import CreateView from './create/CreateView';
import MassEditView from './mass-edit/MassEditView';
import MetadataTemplateView from './metadata-template/MetadataTemplateView';
import SearchResultsView from './search-results/SearchResultsView';
import ImportantInfoView from './important-info/ImportantInfoView';
import CalendarView from './calendar/CalendarView';
import HelpMessagesView from './help-messages/HelpMessagesView';
import ReportView from './report/ReportView';
import FieldVisibilityView from './visibility/FieldVisibilityView';

import LocaleContext from 'constants/localization';
import API from 'constants/api';
import '../styles/dam.scss';
import ManageGroupsView from './manage-groups/ManageGroupsView';
import ManageUsersView from './manage-users/ManageUsersView';
import MapSearchView from './map-search/MapSearchView';

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
    };
  }

  static contextType = LocaleContext;

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (error) {
      const err = encodeURIComponent(error.message + '\n' + error.stack);
      // This level of error should be logged to Backend
      fetch(`${API.UI.REPORT_ERROR}&error=${err}`);
    }
  }

  render() {
    const { view, props } = this.props;

    if (this.state.hasError) {
      return <h2 className="warning">{this.context.error.viewCrash}</h2>;
    }

    return (
      {
        display: <DisplayView {...props} />,
        edit: <EditView {...props} />,
        create: <CreateView {...props} />,
        calendar: <CalendarView {...props} />,
        report: <ReportView {...props} />,
        'search-results': <SearchResultsView {...props} />,
        'mass-edit': <MassEditView {...props} />,             
        'metadata-template': <MetadataTemplateView {...props} />,               
        'important-info': <ImportantInfoView {...props} />,
        'help-messages': <HelpMessagesView {...props} />,
        'field-visibility': <FieldVisibilityView {...props} />,
        'manage-groups': <ManageGroupsView {...props} />,
        'manage-users': <ManageUsersView {...props} />,
        'map-search': <MapSearchView {...props} />,
        '': null
      }[view || '']
    );
  }
}

export default View;